<template>
  <div
    v-if="badgeText"
    :class="['badge', badgeClass]"
  >
    {{ badgeText }}
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  isBeta: { type: Boolean, default: false },
  isSoon: { type: Boolean, default: false },
  isUpgrade: { type: Boolean, default: false },
  isNew: { type: Boolean, default: false },
});

const badgeText = computed(() => {
  if (props.isBeta) {
    return 'Beta';
  }
  if (props.isSoon) {
    return 'Soon';
  }
  if (props.isUpgrade) {
    return 'Upgrade';
  }
  if (props.isNew) {
    return 'New';
  }
  return '';
});

const badgeClass = computed(() => {
  if (props.isBeta) {
    return 'badge-beta';
  }
  if (props.isSoon) {
    return 'badge-soon';
  }
  if (props.isUpgrade) {
    return 'badge-upgrade';
  }
  if (props.isNew) {
    return 'badge-new';
  }
  return '';
});
</script>

<style scoped lang="less">
.badge {
  height: 17px;
  border-radius: 32px;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  margin-top: -10px;
  &.badge-beta {
    color: @basic-pink;
    background-color: fade(@basic-pink, 10%);
  }
  &.badge-new {
    color: @white;
    background-color: @basic-green;
  }
  &.badge-soon {
    color: @basic-blue;
    background-color: fade(@basic-blue, 10%);
  }
  &.badge-upgrade {
    color: @white;
    background: linear-gradient(90deg, @bg-brand-default 0%, @indigo-100 100%);
  }
}
</style>
